// extracted by mini-css-extract-plugin
export default {"root":"styles_root__A4Fvz","text":"styles_text__a4Kxn"};